import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const isFree = type === 'free';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'grey.50',
        py: 6,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          {/* 成功アイコン */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: 'success.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <CheckCircle sx={{ fontSize: 50, color: 'success.main' }} />
          </Box>

          {/* メインメッセージ */}
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {isFree ? '登録完了!' : 'ご購入ありがとうございます!'}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {isFree
              ? 'アカウントが作成されました。以下の手順でサービスを開始できます。'
              : 'お支払いが完了しました。以下の手順でサービスを開始できます。'}
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* 次のステップ */}
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" gutterBottom>
              次のステップ
            </Typography>

            <List>
              <ListItem>
                <ListItemIcon>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    1
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary="メールを確認"
                  secondary="ログイン情報が記載されたメールをお送りしました"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    2
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary="パスワードを設定"
                  secondary="メールに記載されたリンクからパスワードを設定してください"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    3
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary="サービス開始"
                  secondary="ログインしてサービスをご利用ください"
                />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* 注意事項 */}
          <Alert severity="info" sx={{ textAlign: 'left', mb: 3 }}>
            <Typography variant="body2">
              メールが届かない場合は、迷惑メールフォルダをご確認ください。
              それでも届かない場合は、サポートまでお問い合わせください。
            </Typography>
          </Alert>

          {/* ボタン */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => window.close()}
            >
              閉じる
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default CheckoutSuccessPage;
